import { combineReducers } from 'redux';
import { ApiReducerKey } from '../../../../../constants';

import create from './create';

export default combineReducers({ [ApiReducerKey.CREATE]: create });
